import moment from 'moment'
import ChatBotImg from '../../../Assets/Images/DashboardMigrants/chatbot.png'
import ChatBotBackground from '../../../Assets/Images/DashboardMigrants/chatbot-cta-bg.jpg'
import ContactMap from '../../../Assets/Images/DashboardMigrants/mapa-02.png'
import Logo1 from '../../../Assets/Images/DashboardMigrants/logo-footer.png'
import Logo2 from '../../../Assets/Images/DashboardMigrants/jalisco-logo-rombo.png'
import Logo3 from '../../../Assets/Images/DashboardMigrants/subsecretaria-de-derechos-humanos-logo.png'
import { Link } from 'react-router-dom'

const MigrantsFooter = ({ showContact = true, showChatbot = true }) => {
  return (
    <footer className="migrants-footer-container">
      {/** ---- CONTACT ---- */}
      {showContact && (
        <div className="col-12 contact-section">
          <h5 className='title-migrates'>Contacto</h5>
          <div className="contact-info">
            <div className="contact-details">
              <div className="contact-details-item">
                <h6 className="subtitle-migrates">Oficina Guadalajara</h6>
                <p className="text-migrates">
                  atencionmigrantes.sgg@jalisco.gob.mx <br />
                  Tel. +52 (33) 1001 8601 <br />
                  Dirección: Calle Jesús García #720, Col El
                </p>
              </div>
              <div className="contact-details-item">
                <h6 className="subtitle-migrates">Oficina Los Ángeles</h6>
                <p className="text-migrates">
                  oficina.losangeles.sgg@jalisco.gob.mx <br />
                  Tel. +1 (562) 841 7792 <br />
                  Tel. +1 (562) 841 7388 <br />
                  Dirección: 3200 Mulford Ave. Suite 201 <br />
                  Lynwood Ca 90262
                </p>
              </div>
              <div className="contact-details-item">
                <h6 className="subtitle-migrates">Oficina Chicago</h6>
                <p className="text-migrates">
                  oficina.chicago.sgg@jalisco.gob.mx <br />
                  Tel. +1 (708) 477 9398 <br />
                  Dirección: 1600 W Lake St, Melrose Park, Il
                  <br />
                  60160, Estados Unidos
                </p>
              </div>
            </div>
            <div className="contact-image">
              <img src={ContactMap} alt="Contact Map" />
            </div>
          </div>
        </div>
      )}
      {/** ---- CHATBOT ---- */}
      {showChatbot && (
        <div
          className="col-12 chatbot-section"
          style={{
            backgroundImage: `url(${ChatBotBackground})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <img src={ChatBotImg} alt="chatbot" />
          <h5 className="title-migrates">Chatbot CTA</h5>
          <p className="text-migrates">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur
            fringilla congue tempus. In et vestibulum mauris. Aliquam faucibus,
            felis ut blandit gravida, felis odio bibendum massa, id pretium
            felis urna vitae lacus. Maecenas sed velit semper, ullamcorper odio
            id, pulvinar dolor. In aliquet semper vulputate.
          </p>
          <Link to={'/#'} className="btn btn-migrates">
            VER MÁS
          </Link>
        </div>
      )}
      <div className="migrants-footer-logos">
        <div>
          <div className="footer-logo">
            <div>
              <img src={Logo1} alt="logo-migrantes" />
            </div>
            <div>
              <img src={Logo2} alt="logo-jalisco" />
            </div>
            <div>
              <img src={Logo3} alt="logo-secretaria" />
            </div>
          </div>
          <div className="footer-text">
            <span className="text-migrates">
              Gobierno del Estado de Jalisco © {moment().format('YYYY')}. <br />
              Desarrollado por Enigmatech.
            </span>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default MigrantsFooter
